import Discovery from "../components/discovery/Discovery";

const Dashboard = () => {
  return (
    <div className="px-4 pt-6">
      <Discovery />
    </div>
  );
}

export default Dashboard;
